import { render, staticRenderFns } from "./ArtworkCommentModal.vue?vue&type=template&id=c9eb1024&scoped=true&"
import script from "./ArtworkCommentModal.vue?vue&type=script&lang=js&"
export * from "./ArtworkCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkCommentModal.vue?vue&type=style&index=0&id=c9eb1024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9eb1024",
  null
  
)

export default component.exports